import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import { GeneralDocument } from "@/services/GeneralDocument";
import GeneralDocumentService from "@/services/GeneralDocument";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "panduan"
})
class PanduanStore extends VuexModule {
  public listPanduan: GeneralDocument[] = [];

  @Mutation
  SET_PANDUAN(data: GeneralDocument[]) {
    this.listPanduan = data;
  }

  @Action
  public async fetchPanduan(search: string | null = null) {
    const resp = await GeneralDocumentService.getGeneralDocumentList({
      search: search,
      scope: "aktif"
    });
    this.SET_PANDUAN(resp || []);
  }
}

export const PanduanStoreModule = getModule(PanduanStore);

export default {
  PanduanStoreModule
};
